import { forwardRef, useEffect, useState } from 'react';
// @mui
import { Box, Stack, Typography, Button, Divider, Slide, Dialog } from '@mui/material';
import { TransitionProps } from '@mui/material/transitions';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
// components
import Scrollbar from 'src/components/scrollbar';

import { getProviderList } from 'src/api/game';
import { useRouter } from 'src/routes/hooks';
import { paths } from 'src/routes/paths';

// eslint-disable-next-line prefer-arrow-callback
const Transition = forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const ProviderList = ({ status, onCloseModal }: { status: boolean; onCloseModal: () => void }) => {
  const router = useRouter();
  
  const [providers, setProviders] = useState<any[]>([]);
  const [activeProvider, setActiveProvider] = useState("");

  // const getCategoryData = async () => {
  //   const response = await getCategories();

  //   if (response.length) {
  //     const categoryArray = response.map(({ _id, name }: { _id: string, name: string }) => ({ label: name, value: _id }));
  //     setCategories(categoryArray);
  //   }
  // };

  const getProviderData = async () => {
    const response = await getProviderList({});

    if (response.length) {
      const providerArray = response.map(
        ({ _id, vendorName }: { _id: string; vendorCode: string; vendorName: string }) => ({
          label: vendorName,
          value: _id,
        })
      );
      setProviders(providerArray);
    }
  };

  useEffect(() => {
    getProviderData();
  }, []);

  const handleClickProvider = async (provider: string) => {
    setActiveProvider(provider);
    router.push(`${paths.dashboard.game}?provider=${provider}`);

    onCloseModal();
  }

  return (
    <Dialog
      open={status}
      TransitionComponent={Transition}
      maxWidth="xs"
      fullWidth
      onClose={onCloseModal}
      sx={{
        '& .MuiModal-backdrop': {
          backdropFilter: 'blur(8px)',
        },
        '& .MuiDialog-paper': {
          width: { xs: '90%' },
          backgroundColor: '#111128',
          py: 3,
          px: 2,
        },
      }}
    >
      <Scrollbar>
        <Box
          gap={1}
          display="grid"
          gridTemplateColumns={{
            xs: 'repeat(2, 1fr)',
            sm: 'repeat(3, 1fr)',
          }}
          sx={{
            width: 1,
            mt: 2,
          }}
        >
          {providers.map((provider: any, index: number) => (
            <Stack key={index} direction="column">
              <Button
                variant={activeProvider === provider.value ? 'outlined' : 'text'}
                endIcon={activeProvider === provider.value && <CheckCircleIcon />}
                sx={{
                  minWidth: 'initial',
                  px: 1,
                  py: 1,
                  color: '#fff',
                  borderRadius: 1,
                  justifyContent: 'space-between',
                }}
                onClick={() => handleClickProvider(provider.value)}
              >
                <Typography noWrap>{provider.label}</Typography>
              </Button>
              <Divider sx={{ mt: 0.5 }} />
            </Stack>
          ))}
        </Box>
      </Scrollbar>
    </Dialog>
  );
};

export default ProviderList;